export const SYNC_STATUS = {
  NOT_SYNC: 'NOT_SYNC',
  SYNCED: 'SYNCED',
  ERROR_SYNC: 'ERROR_SYNC',
};

export const STATUS_LABELS = {
  [SYNC_STATUS.NOT_SYNC]: 'Não sincronizado',
  [SYNC_STATUS.SYNCED]: 'Sincronizado',
  [SYNC_STATUS.ERROR_SYNC]: 'Erro ao sincronizar',
};

/** Registros por chamada em POST integrate-entities/reprocessar */
export const REPROCESS_BATCH_LIMIT = 10;

/** Acima disso, pede confirmação antes de iniciar o lote */
export const REPROCESS_CONFIRM_THRESHOLD = 100;

export const STATUS_FILTER_OPTIONS = [
  { id: SYNC_STATUS.NOT_SYNC, nome: STATUS_LABELS[SYNC_STATUS.NOT_SYNC] },
  { id: SYNC_STATUS.SYNCED, nome: STATUS_LABELS[SYNC_STATUS.SYNCED] },
  { id: SYNC_STATUS.ERROR_SYNC, nome: STATUS_LABELS[SYNC_STATUS.ERROR_SYNC] },
];

/** Mapeamento para renderStatus (classes em cell-renderers/status.js) */
export const statusToChip = (status) => {
  const label = STATUS_LABELS[status] || status;
  if (status === SYNC_STATUS.SYNCED) {
    return { value: 'VALIDADO', label };
  }
  if (status === SYNC_STATUS.ERROR_SYNC) {
    return { value: 'INVALIDADO', label };
  }
  return { value: 'AGUARDANDO', label };
};

export const EMPTY_RESUMO = {
  filtrado: {},
  total: {},
  serie: [],
  sparklines: {},
};

export const normalizeResumo = (data) => {
  if (!data || typeof data !== 'object') {
    return EMPTY_RESUMO;
  }
  const filtrado =
    data.filtrado && typeof data.filtrado === 'object' ? data.filtrado : {};
  const total = data.total && typeof data.total === 'object' ? data.total : {};
  const serie = Array.isArray(data.serie) ? data.serie : [];
  const sparklines =
    data.sparklines && typeof data.sparklines === 'object' ? data.sparklines : {};
  if (data.filtrado == null && data.total == null && !Array.isArray(data.serie)) {
    return { filtrado: data, total: {}, serie: [], sparklines: {} };
  }
  return { filtrado, total, serie, sparklines };
};

export const getStatusCount = (counts, status) => {
  if (!counts) return null;
  return counts[status] ?? null;
};

export const sumFiltradoCounts = (filtrado) => {
  if (!filtrado || typeof filtrado !== 'object') return 0;
  return (
    (filtrado[SYNC_STATUS.NOT_SYNC] ?? 0) +
    (filtrado[SYNC_STATUS.SYNCED] ?? 0) +
    (filtrado[SYNC_STATUS.ERROR_SYNC] ?? 0)
  );
};

export const sumTotalCounts = (total) => {
  if (!total || typeof total !== 'object') return null;
  const sum =
    (total[SYNC_STATUS.NOT_SYNC] ?? 0) +
    (total[SYNC_STATUS.SYNCED] ?? 0) +
    (total[SYNC_STATUS.ERROR_SYNC] ?? 0);
  return sum || null;
};

export const canReprocess = (status) =>
  status === SYNC_STATUS.NOT_SYNC || status === SYNC_STATUS.ERROR_SYNC;

export const formatJsonBody = (body) => {
  if (body == null || body === '') return '—';
  try {
    const parsed = typeof body === 'string' ? JSON.parse(body) : body;
    return JSON.stringify(parsed, null, 2);
  } catch {
    return String(body);
  }
};

/** Nome do digitador no payload NSMP (`typed_by`); fallback para join da API */
export const getDigitadorFromBody = (body, fallbackNome) => {
  if (fallbackNome != null && String(fallbackNome).trim() !== '') {
    return String(fallbackNome).trim();
  }
  if (body == null || body === '') return null;
  try {
    const parsed = typeof body === 'string' ? JSON.parse(body) : body;
    const typedBy = parsed?.typed_by;
    if (typedBy != null && String(typedBy).trim() !== '') {
      return String(typedBy).trim();
    }
  } catch {
    /* body inválido */
  }
  return null;
};

export const truncateError = (error, maxLen = 80) => {
  if (!error) return '';
  const text = String(error);
  return text.length > maxLen ? `${text.slice(0, maxLen)}…` : text;
};

const DAY_MS = 86400000;

/** ≤3 meses → dia; >3 e ≤6 meses → semana; >6 meses → mês */
export const resolveVolumeGroupBy = (inicio, fim) => {
  if (inicio == null || fim == null) return 'DAY';
  const spanDays = Math.max(0, Math.floor((Number(fim) - Number(inicio)) / DAY_MS));
  if (spanDays > 183) return 'MONTH';
  if (spanDays > 92) return 'WEEK';
  return 'DAY';
};

export const GROUP_BY_LABELS = {
  DAY: 'Agrupado por dia',
  WEEK: 'Agrupado por semana',
  MONTH: 'Agrupado por mês',
};

/** Body enviado à API (inicio/fim + malhaIds + digitadorIds + status opcional) */
export const normalizeFilterForApi = (filter) => {
  if (!filter || typeof filter !== 'object') return {};

  const body = {};
  if (filter.inicio != null) body.inicio = filter.inicio;
  if (filter.fim != null) body.fim = filter.fim;
  if (filter.nsirId) body.nsirId = filter.nsirId;
  if (filter.status) body.status = filter.status;

  if (Array.isArray(filter.malhaIds) && filter.malhaIds.length > 0) {
    body.malhaIds = filter.malhaIds;
  } else if (filter.malhaId) {
    body.malhaIds = Array.isArray(filter.malhaId) ? filter.malhaId : [filter.malhaId];
  }

  if (Array.isArray(filter.digitadorIds) && filter.digitadorIds.length > 0) {
    body.digitadorIds = filter.digitadorIds;
  } else if (filter.digitadorId != null && filter.digitadorId !== '') {
    body.digitadorIds = Array.isArray(filter.digitadorId)
      ? filter.digitadorId
      : [filter.digitadorId];
  }

  return body;
};
